// import { User } from '../../Items/User';
// import * as actionType from '../action';

// interface UserState {
//     users: User[];
//     loggedUser: User | null;
// }
  
//   const initialState: UserState = {
//     users: [],
//     loggedUser: null,
// };



// const UserReducer = (state = initialState, action: any): UserState => {
//     switch (action.type) {
//         case actionType.GET_USERS: {
//             return { ...state, users: action.payload };
//         }
//         case actionType.ADD_USER:{
//             // const users = [...state.users];
//             // users.push(action.payload);
//             // return { ...state, users };
//             return { ...state, users: [...state.users, action.payload] };
//         }
//         case actionType.EDIT_USER:{
//             return {
//                 ...state,
//                 users: state.users.map((u) =>
//                   u.id === action.payload.id ? action.payload : u
//                 ),
//             };
//         }
//         case actionType.DELETE_USER:{
//             return {
//               ...state,
//               users: state.users.filter((u) => u.id !== action.payload),
//             };
//         }
//         case actionType.SIGN_IN:{
//             return { ...state, loggedUser: action.payload };
//         }
            
//         default:
//             return { ...state };


//     }
// }

// export default UserReducer;

import { User } from '../../Items/User';
import * as actionType from '../action';

export interface UserState {
    users: User[];
    loggedUser: User | null;
}

const initialState: UserState = {
    users: [],
    loggedUser: null,
};

const UserReducer = (state: UserState = initialState, action: any): UserState => {
    switch (action.type) {
        case actionType.GET_USERS:
            return { ...state, users: action.payload ?? [] };

        case actionType.ADD_USER:
            return { ...state, users: [...state.users, action.payload] };

        case actionType.EDIT_USER:
            return {
                ...state,
                users: state.users.map(u => u.id === action.payload.id ? action.payload : u),
            };

        case actionType.DELETE_USER:
            return {
                ...state,
                users: state.users.filter(u => u.id !== action.payload),
            };

        case actionType.SIGN_IN:
            return { ...state, loggedUser: action.payload ?? null };

        case "SIGN_OUT": 
        
        localStorage.removeItem("user");
        return {
            ...state,
            loggedUser: null   
           
        };
        default:
            return state;
    }
};

export default UserReducer;
